import * as React from 'react';
import * as classnames from "classnames"
import {resetImage} from '../../common/reset-image';
import SampleLink from './sample-link';
import './index.scss';


export default function Index ( props: any ) {
    const { sampleInfo = {}, sku, i18n, price} = props;
    if (!price) return null;
    const {skuSample} = sku;
    const {unit} = price;
    const {
      formatOriginalPrice,
      formatPrice,
    } = sampleInfo;
    // 没有样品价格，不展示样品
    if ( !formatPrice ) return null;

    const renderSample = ( item: any ) => {
        const cls = classnames( {
            "sample-sku": true,
            "color": !item["originImage"] && item['color']
        } );

        return <span className={cls} key={item.id} style={{
            background: item.originImage ? null : item["color"]
        }}>
            {item["originImage"] ? <img src={resetImage(item.originImage, '50', 'xz')} /> :
                item["color"] ? null : item["name"]
            }
        </span>;
    };

    // 是否展示样品单
    return (
        <div className="buyer-sample" id="buy-sample">
            <label>{i18n["btnGetSample.sample"]}:</label>
            <div className="sample-list">
                {skuSample && skuSample[0]?.values && <div className="sample-info">
                    {skuSample[0].values.map( ( item: SkuAttr ) => renderSample( item ) )}
                </div>}
                <div className="sample-info">
                    <strong className="sample-item">{formatPrice}/{unit}</strong>
                    <span className="sample-item">
                    {i18n["marketAction.moqName"]} : 1 {unit}
                    </span>
                    <SampleLink {...props} type="sample" startOrder/>
                </div>
                <p>
                  <del>{formatOriginalPrice}</del>
                </p>
            </div>
        </div>
    );
}
